import React from 'react';
import { Modal, Button, message } from 'antd';
import './index.scss';
import Scrollbars from 'react-custom-scrollbars-2';
import domtoimage from "dom-to-image"
import jsPDF from 'jspdf';
import { CommmonGet, CommonDown } from '@/util/network/api';

interface ViewExamTicketModalProps {
  visible: boolean;
  onCancel: () => void;
  onEdit: () => void;
  // onDownload: () => void;
  data: any;
}

const ViewExamTicketModal: React.FC<ViewExamTicketModalProps> = ({
  visible,
  onCancel,
  onEdit,
  // onDownload,
  data,
}) => {
    const { 
        candidateNumber, 
        userName, 
        genderStr, 
        idCard, 
        examCardTitle, 
        examAddress, 
        examSubjectCount, 
        examNotice, 
        examCardNumber, 
        graduationSchoolName, 
        examRoom, 
        seatNumber,
        candidatePhoto,
        volunteerList,
        examSubjectTimeList
    } = data;

    const onDownload = () => {
      message.loading("准考证导出中...", 0);
      CommmonGet('/examCard/getCardImage', {planId:data.planId, userId: data.userId})
      .then((res: any) => {
        if(res){
          CommonDown(res, {}).then((res: any) => {
            console.log(res, 'res')
            const url = window.URL.createObjectURL(res);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.download = decodeURI( `${examCardTitle}-${userName}准考证信息.png`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }).finally(() => {
              message.destroy();
          })
        }
        
          
      })
      
    }
  return (
    <Modal
      title="查看准考证"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={900}
      className="view-exam-ticket-modal"
    >
      {/* 顶部考生信息栏 */}
      <div className="header-bar">
        <div className="student-info">
          <span>考生号: {candidateNumber||"--"}</span>
          <span>姓名: {userName||"--"}</span>
          <span>性别: {genderStr||"--"}</span>
          <span>身份证号: {idCard||"--"}</span>
        </div>
        <div className="header-buttons">
          <Button type="primary" className="download-btn" onClick={onDownload}>下载准考证</Button>
        </div>
      </div>
    <Scrollbars style={{
        height: 600
    }}>
      {/* 准考证主体内容 */}
      <div className="ticket-content">
        <h2 className="ticket-title">{examCardTitle||"--"}</h2>
        <p className="ticket-address">考点地址: {examAddress||"--"}</p>

        <table className="ticket-table">
          <tbody>
            <tr>
              <td className='ticket-table-name'>准考证号</td>
              <td>{examCardNumber||"--"}</td>
              <td className='ticket-table-name'>姓名</td>
              <td>{userName||"--"}</td>
              <td rowSpan={5} className="photo-cell">
                {candidatePhoto?.url ? (
                  <img src={candidatePhoto.url + `?t=` + new Date().getTime()} alt="考生照片" className="photo-img" />
                ) : (
                  <span className="photo-placeholder">照片未上传</span>
                )}
              </td>
            </tr>
            <tr>
              <td className='ticket-table-name'>身份证号</td>
              <td colSpan={3}>{idCard||"--"}</td>
            </tr>
            <tr>
              <td className='ticket-table-name'>高考考生号</td>
              <td>{candidateNumber||"--"}</td>
              <td className='ticket-table-name'>毕业中学</td>
              <td>{graduationSchoolName||"--"}</td>
            </tr>
            <tr>
              <td className='ticket-table-name'>考场</td>
              <td colSpan={3}>{examRoom||"--"}</td>
            </tr>
            <tr>
              <td className='ticket-table-name'>座位号</td>
              <td colSpan={3}>{seatNumber||"--"}</td>
            </tr>

            {/* 专业志愿 */}
            <tr>
              <td className="label-td ticket-table-name">专业志愿</td>
              <td colSpan={4}>
                {volunteerList && volunteerList.map((major, index) => (
                  <div key={index} className="major-item">
                    {major}
                    {/* 第{index + 1}志愿 {major} */}
                  </div>
                ))}
              </td>
            </tr>

            {/* 考试时间 */}
            <tr>
              <td className="label-td ticket-table-name">考试时间</td>
              <td colSpan={4}>
                {examSubjectTimeList && examSubjectTimeList.map((time, index) => (
                  <div key={index} className="time-item">{time.examSubjectName}: {time.examSubjectStartTime}~{time.examSubjectEndTime}</div>
                ))}
              </td>
            </tr>

            {/* 考生须知 */}
            <tr>
              <td colSpan={5} className="notice-header">考生须知</td>
            </tr>
            <tr>
              <td colSpan={5} className="notice-td">
                {examNotice && examNotice.split("\n").map((line, index) => (
                  <p key={index} className="notice-line">{line}</p>
                ))}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </Scrollbars>
    </Modal>
  );
};

export default ViewExamTicketModal;